export default {"src":"/_next/static/media/ic-excel.6398ca90.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};